import React from 'react'
import PropTypes from 'prop-types'

import './inlineSVG.css'

const sprites = (id) => {
  switch (id) {
    case 'hamburger':
      return (
        <svg viewBox='0 0 32 32' aria-labelledby='Hamburger' xmlns='http://www.w3.org/2000/svg'>
          <g fill='currentColor'>
            <path d='M1 7h30a1 1 0 0 0 0-2H1a1 1 0 0 0 0 2z' />
            <path d='M31 15H1a1 1 0 0 0 0 2h30a1 1 0 0 0 0-2z' />
            <path d='M31 25H1a1 1 0 0 0 0 2h30a1 1 0 0 0 0-2z' />
          </g>
        </svg>
      )
    case 'close':
      return (
        <svg viewBox='0 0 24 24' aria-labelledby='Close' xmlns='http://www.w3.org/2000/svg'>
          <path d='M1.922.508L.508 1.922l10.08 10.08L.512 22.078l1.414 1.414 10.076-10.076 10.07 10.07 1.414-1.414-10.07-10.07L23.492 1.926 22.078.512 12.002 10.588 1.922.508z' fill='currentColor' fillRule='evenodd' />
        </svg>
      )
    case 'globe':
      return (
        <svg viewBox='0 0 20 20' aria-labelledby='Language' xmlns='http://www.w3.org/2000/svg'>
          <path d='M9.991 1.667c-4.6 0-8.325 3.733-8.325 8.333s3.725 8.333 8.325 8.333c4.608 0 8.342-3.733 8.342-8.333S14.599 1.667 9.99 1.667Zm5.775 5h-2.458a13.042 13.042 0 0 0-1.15-2.967 6.691 6.691 0 0 1 3.608 2.967Zm-5.767-3.3c.692 1 1.234 2.108 1.592 3.3H8.408c.358-1.192.9-2.3 1.591-3.3Zm-6.45 8.3A6.87 6.87 0 0 1 3.333 10c0-.575.083-1.133.216-1.667h2.817c-.067.55-.117 1.1-.117 1.667s.05 1.117.117 1.667H3.549Zm.684 1.666H6.69a13.04 13.04 0 0 0 1.15 2.967 6.655 6.655 0 0 1-3.608-2.967ZM6.69 6.667H4.233A6.656 6.656 0 0 1 7.84 3.7a13.04 13.04 0 0 0-1.15 2.967Zm3.308 9.966c-.691-1-1.233-2.108-1.591-3.3h3.183c-.358 1.192-.9 2.3-1.592 3.3Zm1.95-4.966h-3.9A12.26 12.26 0 0 1 7.916 10c0-.567.058-1.125.133-1.667h3.9c.075.542.134 1.1.134 1.667s-.059 1.117-.134 1.667Zm.209 4.633c.5-.925.883-1.925 1.15-2.967h2.458a6.691 6.691 0 0 1-3.608 2.967Zm1.475-4.633c.066-.55.116-1.1.116-1.667s-.05-1.117-.116-1.667h2.816c.134.534.217 1.092.217 1.667s-.083 1.133-.217 1.667h-2.816Z' fill='currentColor' />
        </svg>
      )
    default:
      break
  }
}

const InlineSVG = (props) => {
  const classname = props.className || ''
  const cls = 'icon icon--' + props.icon + ' ' + classname

  return (
    <span className={cls} onClick={props.onClick}>
      { sprites(props.icon) }
    </span>
  )
}

InlineSVG.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func
}

export default InlineSVG



// WEBPACK FOOTER //
// ./src/components/InlineSVG/index.js